var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtpPaymentFeaturesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 323,
    viewBox: "0 0 502 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.263 157.707C228.827 108.414 298.049 81 369.95 81H852L609.765 323H1.43051e-05L176.263 157.707Z",
    fill: "#262866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M375.217 91.8599C436.798 32.9294 519.01 -8.22544e-06 604.557 -8.22544e-06H955L743.207 227H234L375.217 91.8599Z",
    fill: "#3E8BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtpPaymentFeaturesBg);
export default __webpack_public_path__ + "static/media/RtpPaymentFeaturesBg.bff3a96a4ee6b66ef9380a7f56721f0e.svg";
export { ForwardRef as ReactComponent };